import { Stack, Typography } from "@mui/material";
import { Button } from "@mui/material";
import {
  type CardListItemType,
  CardsList,
} from "Components/Shared/CardsList/CardsList";

type Props = {
  listItems: Array<CardListItemType>;
  noItemsText: string;
  addButtonConfig: {
    onClick: () => void;
    text: string;
  };
  isReadOnly?: boolean;
};

export const ControlledCardsList = ({
  listItems,
  isReadOnly,
  addButtonConfig: { onClick, text },
  noItemsText,
}: Props) => (
  <Stack justifyContent="flex-end">
    {listItems.length ? (
      <CardsList items={listItems} />
    ) : (
      <Typography mb={2}>{noItemsText}</Typography>
    )}
    {!isReadOnly && (
      <Button
        color="primary"
        variant="text"
        onClick={onClick}
        sx={{ textTransform: "none" }}
      >
        {text}
      </Button>
    )}
  </Stack>
);
